<section class="rcx-table">
    <div class="row">
        <div class="col-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body">
                        <div class="row g-2 mb-3 align-items-center">
                            <div class="col-12 col-md-auto">
                                <h5 class="card-title m-0">
                                    <i class="bx bx-book me-1 text-primary"></i>Review
                                </h5>
                            </div>
                        
                            <div class="col-12 col-sm-6 col-md-3 col-lg-2">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="search"
                                        ngbTooltip="Filter by From date." placement="top" container="body">
                                        <i class="bx bx-calendar-week"></i>
                                    </span>
                                    <input type="date" class="form-control border-start-0" id="search"
                                        placeholder="From date..." autocomplete="off" [(ngModel)]="fromDate">
                                </div>
                            </div>
                    
                            <div class="col-12 col-sm-6 col-md-3 col-lg-2">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="search"
                                        ngbTooltip="Filter by To date." placement="top" container="body">
                                        <i class="bx bx-calendar-week"></i>
                                    </span>
                                    <input type="date" class="form-control border-start-0" id="search"
                                        placeholder="To date..." autocomplete="off" [(ngModel)]="toDate"
                                        [min]="fromDate">
                                </div>
                            </div>
                    
                            <div class="col-12 col-sm-6 col-md-3 col-lg-2">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="search" ngbTooltip="Filter by Status."
                                        placement="top" container="body">
                                        <i class="bx bx-filter"></i>
                                    </span>
                                    <select class="form-select" autocomplete="off" id="status" [(ngModel)]="status">
                                        <option hidden value=null disabled selected>Choose...</option>
                                        <option *ngFor="let status of statuses;let i=index" [ngValue]="status">
                                            {{status}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            
                            <div class="col-sm-12 col-md-3 col-lg-2 ps-1">
                                <div class="input-group">
                                    <button type="button" ngbTooltip="Fetch Records." placement="top" container="body"
                                        class="btn btn-secondary btn-sm" (click)="onStatusChange()">
                                        <i class="bx bx-search-alt-2 ri-lg align-middle me-0"></i>
                                    </button>
                                </div>
                            </div>
                            
                            <div class="col-12 col-md-6 col-lg-3 d-flex flex-wrap justify-content-end align-items-center gap-2">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="regularReportCheckbox"
                                        placement="top" container="body" ngbTooltip="Regular Report"
                                        [(ngModel)]="useRegularReport" (change)="onStatusChange()">
                                    <label class="form-check-label" for="regularReportCheckbox">Regular</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="myCheckbox" placement="top"
                                        container="body" ngbTooltip="View all leaves" [(ngModel)]="showAllLeaves"
                                        (change)="onStatusChange()">
                                    <label class="form-check-label" for="myCheckbox">Show All</label>
                                </div>
                                <button type="button" class="btn btn-success btn-sm" ngbTooltip="Download as Excel"
                                    placement="top" container="body" (click)="downloadExcel()">
                                    <i class="bx bx-download"></i>
                                </button>
                            </div>
                        </div>
                        
                        <div class="table-responsive">
                            <table class="table table-hover" id="table">
                                <thead id="table-thead" class="bg-light">
                                    <tr>
                                        <th scope="col" width="5%">#</th>
                                        <th scope="col" width="15%">Employee</th>
                                        <th scope="col" *ngIf="!useRegularReport" width="10%">Type</th>
                                        <th scope="col" width="10%">From</th>
                                        <th scope="col" width="10%">To</th>
                                        <th scope="col" width="10%">Duration</th>
                                        <th scope="col" width="15%">Reason</th>
                                        <th scope="col" width="10%" class="text-center">Comment</th>
                                        <th scope="col" width="5%" class="text-center">Count</th>
                                        <th scope="col" width="10%" class="text-center">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let vacay of vacays; let i=index">
                                        <td>{{i+1}}.</td>
                                        <td class="text-capitalize">{{ vacay.status === null ? vacay.appliedFor.name : vacay.appliedFor?.name }}</td>
                                        <td class="text-center" *ngIf="!useRegularReport">{{vacay.status === null ? 'ABSENCE' : vacay.leaveType || '-'}}</td>
                                        <td>{{vacay.appliedFrom | date:'MMM dd, yyyy'}}</td>
                                        <td>{{vacay.appliedTo | date:'MMM dd, yyyy'}}</td>
                                        <td>{{vacay.partial ? 'Half Day' : 'Full Day'}}</td>
                                        <td>{{vacay.reason}}</td>
                                        <td class="text-center">{{vacay.comments || vacay.remarks || '-'}}</td>
                                        <td class="text-center">{{useRegularReport ? (vacay.regularCount || '-') : (vacay.leaveCount || '-')}}</td>
                                        <td class="text-center">
                                            <span class="badge rounded-pill bg-{{vacay.status==='APPROVED'?'success':vacay.status==='APPLIED'?'secondary':vacay.status==='REVOKED'?'warning':!vacay?.status?'success':'danger'}} m-1">{{vacay?.status || 'APPROVED'}}</span>
                                        </td>
                                    </tr>
                                    <tr class="no-data">
                                        <ng-container *ngIf="isLoading; else noDataTemplate">
                                            <td colspan="10">Fetching data, please wait...</td>
                                        </ng-container>
                                        <ng-template #noDataTemplate>
                                            <ng-container *ngIf="vacays && vacays.length < 1; else noSearchResults">
                                                <td colspan="10">
                                                    {{ useRegularReport ? 'No regulars were found.' : 'No leaves were found.' }}
                                                </td>
                                            </ng-container>
                                            <ng-template #noSearchResults>
                                                <td colspan="10" *ngIf="searchKeyword && (vacays | search : 'name' : searchKeyword).length == 0">
                                                    {{ useRegularReport ? 'No regulars were found for the search results.' : 'No leaves were found for the search results.' }}
                                                </td>
                                            </ng-template>
                                        </ng-template>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>